import { BannerInfo } from '@fluidx/office-fluid-types';
import { PostMessage } from '../Shared/PostMessage';

export const BannerListenerAttachedMessageType = 'BannerListenerAttached';
export const CreateBannerMessageType = 'CreateBanner';
export const RemoveBannerMessageType = 'RemoveBanner';

export interface BannerListenerAttachedMessage extends PostMessage<typeof BannerListenerAttachedMessageType> {}

export interface CreateBannerMessage extends PostMessage<typeof CreateBannerMessageType> {
  payload: { bannerInfo: BannerInfo };
}

export interface RemoveBannerMessage extends PostMessage<typeof RemoveBannerMessageType> {
  payload: { bannerId: string };
}
